"use strict";

exports.__esModule = true;
exports.MetricQueryController = MetricQueryController;
var _react = _interopRequireDefault(require("react"));
var _APIQueryController = require("../../API/APIQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Executes a metric query and provides the results via render prop.
 */
function MetricQueryController(_ref) {
  var query = _ref.query,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_APIQueryController.APIQueryController, {
    url: "/api/v3/timeseries-metrics/",
    method: "POST",
    body: query
  }, children);
}